import React from 'react';
import HeroSection from './HeroSection';
import FeatureShowcase from './FeatureShowcase';
import FormTypesShowcase from './FormTypesShowcase';
import Brand from './Brand';
import MainSection from './MainSection';
import Repair from './Repair';
import FeatureSection from './FeatureSection';
import RepairManagement from './RepairManagement';
import ShopifyApp from './ShopifyApp';
import ContactSection from './ContactSection';
import FAQSection from './FAQSection';
import BlogSection from './BlogSection';


function Home() {
  return (
    <div>
    <HeroSection />
    <FeatureShowcase />
    <FormTypesShowcase />
    {/* <Brand /> */}
    {/* <MainSection /> */}
    <Repair/>
    {/* <FeatureSection /> */}
    <RepairManagement />
    <ShopifyApp />
    <ContactSection />
    <FAQSection />
    {/* <BlogSection/> */}
    </div>

  );
}

export default Home;
